import "./Mission.css";
import { Container } from "react-bootstrap";
import { useHrStyles } from "../../Context/HRContext";

export default function Mission() {
  const hrStyles = useHrStyles();
  return (
    <Container className="mission-container">
      <h2 className="team-heading" style={{ marginTop: "25px" }}>
        Our Mission
      </h2>
      <p className="mission-text">
        At BEAMS, our mission is to shape the future of construction and
        architecture by turning visionary ideas into reality. We are dedicated
        to delivering unparalleled engineering, architectural, and management
        solutions that emphasize innovation, sustainability, and excellence. By
        fostering collaboration and focusing on client needs, we aim to create
        structures that inspire, endure, and enhance communities for
        generations.
      </p>
      <h2 className="team-heading" style={{ marginTop: "25px" }}>
        Our Vision
      </h2>
      <p className="mission-text">
        Our vision at BEAMS is to be a global leader in transforming the built
        environment through creativity, technology, and commitment. We aspire to
        redefine standards in construction and design, building spaces that
        harmonize functionality with aesthetics. By championing sustainable
        practices and empowering our teams, we envision a world where every
        project contributes to a smarter, greener, and more connected future.
      </p>
      <hr style={hrStyles} />
    </Container>
  );
}
